import { faEye, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from 'Common/Loader';
import DataGrid, { Column } from 'devextreme-react/cjs/data-grid';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { GetOldGoldPurchaseOrderItemList, GetOldGoldPurchaseOrderVoucher } from '../services';
import CustomStore from 'devextreme/data/custom_store';
import { HttpStatus } from 'modules/core';

interface ActionButtonsModalProp {
    selectedId: string;
}

const ActionButtonsModal: React.FC<ActionButtonsModalProp> = ({ selectedId }) => {
    const [loading, setLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showVoucherModal, setShowVoucherModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async () => {
                try {
                    const response = await GetOldGoldPurchaseOrderItemList(selectedId);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    };

    const handleVoucherData = async () => {
        setLoading(true);
        try {
            const response = await GetOldGoldPurchaseOrderVoucher(selectedId);
            if (response.status === HttpStatus.Success) {
                setPdfData(response.data);
                setShowVoucherModal(true);
            }
        } catch (error) {
            console.error("Failed to load PDF", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}

            <button className='btn btn-sm action-btn' onClick={() => setShowViewModal(true)}>
                <FontAwesomeIcon icon={faEye} className="ml-2" />
            </button>

            <button className='btn btn-sm action-btn' onClick={handleVoucherData}>
                <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" />
            </button>

            <Modal size='xl' show={showViewModal} onHide={() => setShowViewModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DataGrid dataSource={dataSource()} showBorders={true}>
                        <Column dataField="karat" caption="Metal Kt" />
                        <Column dataField="rate" caption="Rate" format="fixedPoint" cssClass='text-center' />
                        <Column dataField="purity" caption="Purity (%)" format="fixedPoint" />
                        <Column dataField="netWeight" caption="Net Weight" format="#,##0.000" />
                        <Column dataField="equivalentWeight" caption="Equivalent Weight" format="#,##0.000" />
                        <Column dataField="purchaseAmount" caption="Purchase Amount" format="#,##0.00" />
                        <Column dataField="note" caption="Note" />
                        <Column dataField="calculatedWeight" caption="Calculated Weight" format="#,##0.000" />
                    </DataGrid>
                </Modal.Body>
            </Modal>

            <Modal size='lg' show={showVoucherModal} onHide={() => setShowVoucherModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Purchase Order Voucher</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            title="Voucher PDF"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>No PDF available.</p>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ActionButtonsModal;
